import { gql } from 'apollo-angular';

export const QueryMasterWageRatesNotInProject = gql`
  query masterWageRatesNotInProject(
    $skip: Int
    $take: Int
    $tenantId: UUID!
    $jurisdictionLocationId: UUID!
    $constructionTypeId: UUID!
    $modificationId: UUID!
    $legacyProjectId: Int
    $projectId: UUID
    $where: ClassificationRateFilterInput
    $order: [ClassificationRateSortInput!]
  ) {
    masterWageRatesNotInProject(
      skip: $skip
      take: $take
      tenantId: $tenantId
      jurisdictionLocationId: $jurisdictionLocationId
      constructionTypeId: $constructionTypeId
      modificationId: $modificationId
      legacyProjectId: $legacyProjectId
      projectId: $projectId
      where: $where
      order: $order
    ) {
      totalCount
      items {
        craftClassification {
          name
          craft {
            name
          }
        }
        wageRate {
          baseWageRate
          standardHoursDay
          footNotes {
            name
          }
          baseFringeRate
          totalHourlyRate
          totalOvertimeRate
        }
        constructionTypeId
        craftClassificationId
        createdBy
        createdDate
        expirationDate
        id
        issueDate
        jurisdictionLocationId
        modifiedBy
        modifiedDate
        ownerTenantId
        publicationDate
        trainingType
        wageDeterminationModificationId
        wageRateShiftTypeId
        wageRateStatusTypeId
        wageRateTypeId
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
